/**
 * Shared role constants used across the application.
 *
 * Client roles include client, parent_of_client, and part_of_couple.
 * Used to distinguish staff users from client users in filtering logic.
 */
export const CLIENT_ROLES = ['client', 'parent_of_client', 'part_of_couple'] as const;

/**
 * Returns true if the given roles array contains any client role.
 */
export function isClientRole(roles: string[]): boolean {
  return roles.some(r => (CLIENT_ROLES as readonly string[]).includes(r.toLowerCase()));
}
